import React from 'react'
import { Icon } from 'util/ui'

import styles from './styles.less'

export default function DatePickerCalenderNav({ right, onClick }) {
  return (
    <div
      className={
        right
          ? styles.DatePickerCalenderNav_right
          : styles.DatePickerCalenderNav
      }
      onClick={onClick}
    >
      <Icon name={`arrow ${right ? 'right' : 'left'}`} size="large" />
    </div>
  )
}
